<template>
  <div id="vue-app">
    <div
      data-swiftype-index="true"
      class="entry-content"
    >
      <!-- Regulation table -->
      <section class="mtl">
        <div class="row mtl">
          <div
            v-if="!loading"
            class="large-24 columns"
          >
            <RegulationTable
              key="regulationTable" 
              :regulation-table="regulationTable"
              :page-info="pageInfo"
            />
          </div>
          <div
            v-if="loading"
            class="large-24 columns"
          >
            <div
              v-if="loading"
              class="loading-icon ptxl center"
            >
              <i class="fas fa-spinner fa-spin fa-3x loadingdir" />
            </div>
          </div>
        </div>
      </section>
      <!-- Regulation table -->
    </div> <!-- End .entry-content -->
  </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import RegulationTable from './components/RegulationTable.vue';
import { ClientTable } from 'vue-tables-2';

Vue.use(ClientTable, {
  options: {}, 
  useVuex: false,
  theme: 'bootstrap3',
  template: 'default',
});

export default {
  name: 'App',
  components: {
    RegulationTable,
  },
  data () {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      regulationTable: null,
      loading: false,
      pageInfo: null,
      regulationsUrl: process.env.VUE_APP_REGULATIONS_JSON,
    };
  },
  computed: {
    getPostId: function() {
      return (window.phila_js_vars && window.phila_js_vars.postID) ? window.phila_js_vars.postID : process.env.VUE_APP_TEST_ID;
    },
  },
  mounted () {
    let vm = this;
    vm.init();
  },
  methods: {
    async getPageInfo () {
      let vm = this;
      await axios.get(vm.apiUrl+vm.getPostId)
        .then(response => {
          vm.pageInfo = response.data;
        })
        .catch(() => {
          return false;
        });
    },
    async getRegulationTable () {
      let vm = this;
      const regulationList = vm.regulationsUrl;
      await axios.get(regulationList)
        .then(response => {
          vm.regulationTable = vm.convertArray(response.data);
        })
        .catch(() => {
          return false;
        });
    },
    convertArray(array) {
      return array.map(obj => {
        const supportKeys = Object.keys(obj).filter(key => key.startsWith('support'));
        const supportValues = supportKeys.map(key => obj[key]).filter(value => value !== null);
        const newObj = { ...obj };
        newObj.supporting_documents = supportValues;
        supportKeys.forEach(key => delete newObj[key]);
        return newObj;
      });
    },
    async init () {
      let vm = this;
      vm.loading = true;
      await vm.getPageInfo();
      await vm.getRegulationTable();
      vm.loading = false;
    },
  },
};
</script>